import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
    FiArrowRight,
    FiCompass,
    FiMapPin,
} from "react-icons/fi";

import "./Experiences.css";

import milliy_taom1 from "../photos/osh_tayyorlash.jpg";
import non_yopish1 from "../photos/non_yopish1.jpg";
import ipak_yoli1 from "../photos/ipak_yuli1.jpg";
import kulolchilik1 from "../photos/kulolchilik1.jpg";
import chul_sarguzashti1 from "../photos/chul1.jpg";
import mahalliy_oila1 from "../photos/oila1.jpg";
import hunarmandchilik1 from "../photos/hunarmandchilik1.jpg";
import tog_sayohat1 from "../photos/tog1.jpg";

export default function Experiences() {
    const { t } = useTranslation();

    const experiences = [
        {
            id: "cooking",
            image: milliy_taom1,
            title: t("experiences.cards.cooking.title"),
            location: t("experiences.cards.cooking.location"),
            description: t("experiences.cards.cooking.description"),
        },
        {
            id: "bread",
            image: non_yopish1,
            title: t("experiences.cards.bread.title"),
            location: t("experiences.cards.bread.location"),
            description: t("experiences.cards.bread.description"),
        },
        {
            id: "silk-road",
            image: ipak_yoli1,
            title: t("experiences.cards.silkRoad.title"),
            location: t("experiences.cards.silkRoad.location"),
            description: t("experiences.cards.silkRoad.description"),
        },
        {
            id: "pottery",
            image: kulolchilik1,
            title: t("experiences.cards.pottery.title"),
            location: t("experiences.cards.pottery.location"),
            description: t("experiences.cards.pottery.description"),
        },
        {
            id: "desert",
            image: chul_sarguzashti1,
            title: t("experiences.cards.desert.title"),
            location: t("experiences.cards.desert.location"),
            description: t("experiences.cards.desert.description"),
        },
        {
            id: "family",
            image: mahalliy_oila1,
            title: t("experiences.cards.family.title"),
            location: t("experiences.cards.family.location"),
            description: t("experiences.cards.family.description"),
        },
        {
            id: "crafts",
            image: hunarmandchilik1,
            title: t("experiences.cards.crafts.title"),
            location: t("experiences.cards.crafts.location"),
            description: t("experiences.cards.crafts.description"),
        },
        {
            id: "mountains",
            image: tog_sayohat1,
            title: t("experiences.cards.mountains.title"),
            location: t("experiences.cards.mountains.location"),
            description: t("experiences.cards.mountains.description"),
        },
    ];

    return (
        <>
            <Helmet>
                <title>{t("experiences.meta.title")}</title>

                <meta
                    name="description"
                    content={t("experiences.meta.description")}
                />
            </Helmet>

            <main className="experiences-page">

                {/* HERO */}

                <section className="experiences-hero">

                    <div className="experiences-hero-overlay" />

                    <div className="experiences-hero-content">

                        <span className="experiences-eyebrow">
                            ADAM VOYAGE
                        </span>

                        <h1>
                            {t("experiences.hero.title")}

                            <span>
                                {t("experiences.hero.titleHighlight")}
                            </span>
                        </h1>

                        <p>
                            {t("experiences.hero.description")}
                        </p>

                        <a
                            href="#experiences-list"
                            className="experiences-hero-button"
                        >
                            <span>
                                {t("experiences.hero.button")}
                            </span>

                            <FiArrowRight />
                        </a>

                    </div>

                    <div className="experiences-hero-scroll">

                        <span />

                        <p>
                            {t("experiences.hero.scroll")}
                        </p>

                    </div>

                </section>

                {/* INTRO */}

                <section className="experiences-intro">

                    <div className="experiences-intro-inner">

                        <div className="experiences-intro-label">

                            <FiCompass />

                            <span>
                                {t("experiences.intro.label")}
                            </span>

                        </div>

                        <div className="experiences-intro-content">

                            <h2>
                                {t("experiences.intro.title")}
                            </h2>

                            <p>
                                {t("experiences.intro.description")}
                            </p>

                        </div>

                    </div>

                </section>

                {/* EXPERIENCE LIST */}

                <section
                    className="experiences-list"
                    id="experiences-list"
                >

                    <div className="experiences-grid">

                        {experiences.map((experience, index) => (

                            <Link
                                to={`/experiences/${experience.id}`}
                                className="experience-card"
                                key={experience.id}
                            >

                                <div className="experience-card-image">

                                    {experience.image && (
                                        <img
                                            src={experience.image}
                                            alt={experience.title}
                                        />
                                    )}

                                    <div className="experience-card-overlay" />

                                    <div className="experience-card-number">
                                        {String(index + 1).padStart(2, "0")}
                                    </div>

                                    <div className="experience-card-icon">
                                        <FiArrowRight />
                                    </div>

                                </div>

                                <div className="experience-card-content">

                                    <div className="experience-card-meta">

                                        <span>
                                            {t("experiences.cardLabel")}
                                        </span>

                                        <span>
                                            <FiMapPin />

                                            {experience.location}
                                        </span>

                                    </div>

                                    <h3>
                                        {experience.title}
                                    </h3>

                                    <p>
                                        {experience.description}
                                    </p>

                                    <span className="experience-card-link">

                                        {t("experiences.viewDetails")}

                                        <FiArrowRight />

                                    </span>

                                </div>

                            </Link>

                        ))}

                    </div>

                </section>

                {/* BOTTOM CTA */}

                <section className="experiences-cta">

                    <div className="experiences-cta-inner">

                        <span>
                            ADAM VOYAGE
                        </span>

                        <h2>

                            {t("experiences.cta.title")}

                            <br />

                            <strong>
                                {t("experiences.cta.titleHighlight")}
                            </strong>

                        </h2>

                        <p>
                            {t("experiences.cta.description")}
                        </p>

                        <Link
                            to="/contact"
                            className="experiences-cta-button"
                        >

                            {t("experiences.cta.button")}

                            <FiArrowRight />

                        </Link>

                    </div>

                </section>

            </main>
        </>
    );
}